import {Button, Grid} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface EventJoinButtonProps {
  onClick: () => void;
  isEventFull?: boolean;
  price?: string;
  currency?: string;
  hasUserPaid?: boolean;
  refundRequestPending?: boolean;
  isUserManager?: boolean;
}

const EventJoinButton: React.FC<EventJoinButtonProps> = ({
  onClick,
  isEventFull = false,
  price,
  currency,
  hasUserPaid = false,
  refundRequestPending = false,
  isUserManager = false
}) => {
  const {t} = useTranslation();

  const joinButtonText = isEventFull
    ? t('event_full')
    : price &&
      parseFloat(price) > 0 &&
      currency &&
      !hasUserPaid &&
      !refundRequestPending &&
      !isUserManager
    ? t('event_join_paid', {price: price, currency: currency})
    : refundRequestPending
    ? t('event_refund_request_pending')
    : t('event_join');

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: {xs: 3, sm: 6},
        marginBottom: {xs: 1, sm: 0}
      }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={onClick}
        disabled={isEventFull || refundRequestPending}
        sx={{
          width: '100%'
        }}
      >
        {joinButtonText}
      </Button>
    </Grid>
  );
};

export default EventJoinButton;
